/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  blog,
  calendarios,
  dashboard,
  doctor,
  doctorschedule,
  logout,
  menu,
  menuicon04,
  menuicon06,
  menuicon08,
  menuicon09,
  menuicon10,
  menuicon11,
  menuicon12,
  menuicon14,
  menuicon15,
  menuicon16,
  patients,
  poblacion,
  reportes,
  sidemenu,
} from "../components/imagepath";
import Scrollbars from "react-custom-scrollbars-2";

const Sidebar = (props) => {
  const [sidebar, setSidebar] = useState("");
  const handleClick = (e, item, item1, item3) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);
    e?.target?.className
      ? (ulDiv.style.display = "none")
      : (ulDiv.style.display = "block");
    e?.target?.className
      ? div.classList.remove("subdrop")
      : div.classList.add("subdrop");
  };

  useEffect(() => {
    if (props?.id && props?.id1) {
      const ele = document.getElementById(`${props?.id}`);
      handleClick(ele, props?.id, props?.id1);
    }
  }, []);

  const handleLogout = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    localStorage.clear();
    window.location.href = "/login";
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="submenu">
                  <NavLink
                    className={
                      props?.activeClassName === "Acceso" ? "active" : ""
                    }
                    to="/admin"
                  >
                    <span className="menu-side">
                      <img src={menu} alt="" />
                    </span>{" "}
                    <span>Acceso</span>
                  </NavLink>
                </li>
                <li className="submenu">
                  <NavLink
                    to="#"
                    id="menu-item2"
                    onClick={(e) => handleClick(e, "menu-item2", "menu-items2")}
                  >
                    <span className="menu-side">
                      <img src={poblacion} alt="" />
                    </span>{" "}
                    <span>Población </span> <span className="menu-arrow" />
                  </NavLink>
                  <ul style={{ display: "none" }} className="menu-items2">
                    <li>
                      <NavLink
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/admin/patients"
                      >
                        Población Afiliada{" "}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/admin/patientPresumptive"
                      >
                        Pacientes Potenciales
                      </NavLink>
                    </li>

                    {/* <li>
                      <NavLink className={props?.activeClassName === 'edit-patient' ? 'active' : ''} to="/editpatients">Edit Patients</NavLink>
                    </li> */}
                    {/* <li>
                      <NavLink className={props?.activeClassName === 'patient' ? 'active' : ''} to="/patientsprofile">Patients Profile</NavLink>
                    </li> */}
                  </ul>
                </li>

                <li className="submenu">
                  <NavLink
                    className={
                      props?.activeClassName === "Calendario" ? "active" : ""
                    }
                    to="Calendario"
                  >
                    <span className="menu-side">
                      <img src={calendarios} alt="" />
                    </span>{" "}
                    <span>Calendario</span>
                  </NavLink>
                </li>
                <li className="submenu">
                  <NavLink
                    className={
                      props?.activeClassName === "Calendario" ? "active" : ""
                    }
                    to="Reports"
                  >
                    <span className="menu-side">
                      <img src={reportes} alt="" />
                    </span>{" "}
                    <span>Reportes </span>
                  </NavLink>
                </li>

                <li className="submenu logout-btn">
                  <NavLink to="#" onClick={handleLogout}>
                    <span className="menu-side">
                      <img src={logout} alt="" />
                    </span>{" "}
                    <span>Cerrar Sesión</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default Sidebar;
